import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { Separator } from "@/components/ui/separator";
import { AdminLoginButton } from "@/components/AdminLoginButton";
import { CATEGORIES } from "@/constants/data";

/**
 * Mobile hamburger navigation, shown below the lg breakpoint.
 */
const MobileNav = ({ open, onOpenChange, onOpenInquiry }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetTrigger asChild>
      <Button data-testid="navbar-mobile-menu-button" variant="ghost" size="icon" className="lg:hidden">
        <Menu className="h-6 w-6" />
      </Button>
    </SheetTrigger>
    <SheetContent side="right" className="bg-[color:hsl(var(--background))] w-[85vw] sm:w-[380px] border-l border-[color:var(--line)]">
      <div className="flex flex-col gap-1 mt-10">
        <p className="text-xs uppercase tracking-wide text-[color:hsl(var(--muted-foreground))] px-2 mb-1">Kurumsal</p>
        <SheetClose asChild>
          <Link data-testid="mobile-nav-hakkimizda" to="/hakkimizda" className="px-2 py-3 text-base rounded-[10px] hover:bg-[color:hsl(var(--secondary))]">
            Hakkımızda
          </Link>
        </SheetClose>
        <SheetClose asChild>
          <Link data-testid="mobile-nav-vizyon" to="/vizyon-misyon" className="px-2 py-3 text-base rounded-[10px] hover:bg-[color:hsl(var(--secondary))]">
            Vizyonumuz &amp; Misyonumuz
          </Link>
        </SheetClose>
        <p className="text-xs uppercase tracking-wide text-[color:hsl(var(--muted-foreground))] px-2 mt-4 mb-1">Kategoriler</p>
        {CATEGORIES.map((cat) => (
          <SheetClose asChild key={cat.value}>
            <Link
              data-testid={`mobile-nav-category-${cat.value}`}
              to={`/kategori/${cat.value}`}
              className="px-2 py-3 text-base rounded-[10px] hover:bg-[color:hsl(var(--secondary))]"
            >
              {cat.label}
            </Link>
          </SheetClose>
        ))}
        <Button
          data-testid="mobile-navbar-cta-button"
          onClick={onOpenInquiry}
          className="mt-6 bg-[linear-gradient(135deg,#D4AF37_0%,#C5A059_55%,#E7D7A6_100%)] text-[color:var(--brand-charcoal)] h-12 rounded-[10px] font-medium"
        >
          Talep Oluştur
        </Button>
        <Separator className="bg-[color:var(--line)] mt-6 mb-2" />
        {/* Intentionally does NOT close the Sheet on click: Radix unmounts SheetContent
            (and everything inside it, including this button's own login Dialog/state)
            the instant the Sheet closes, which would tear the login modal down before
            it could ever open. Letting the login Dialog's own overlay render on top of
            the still-open Sheet avoids that and is the simplest reliable fix. */}
        <AdminLoginButton variant="mobile" className="w-full justify-center h-11" />
      </div>
    </SheetContent>
  </Sheet>
);

export default MobileNav;
